/* src/app/modules/portal/components/refresh-data-sources-button/refresh-data-sources-button.component.css */
sh-spinner {
  --sh-spinner-width-s: 24px;
  --sh-spinner-height-s: 24px;
  --sh-spinner-border-width: 0.2rem;
}
.from-now {
  font-style: italic;
}
/*# sourceMappingURL=refresh-data-sources-button.component.css.map */
